import { render, staticRenderFns } from "./NhstFreeUserRegistration.vue?vue&type=template&id=8be3d000&scoped=true"
import script from "./NhstFreeUserRegistration.vue?vue&type=script&lang=js"
export * from "./NhstFreeUserRegistration.vue?vue&type=script&lang=js"
import style0 from "./NhstFreeUserRegistration.vue?vue&type=style&index=0&id=8be3d000&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be3d000",
  null
  
)

export default component.exports